module.exports = __webpack_public_path__ + "static/media/tooltip.9d22a70f.svg";